module.exports = __webpack_public_path__ + "img/step3-en.2e8dd21a.webp";